export const sameAs = [
	'https://github.com/juslin03',
	'https://www.linkedin.com/in/juslin/',
	'https://www.threads.com/@juslin_komenan',
	'https://x.com/misterjuslin',
	'https://www.youtube.com/@MrJuslin',
	'https://www.facebook.com/Juslin.Komenan/'
];

export const keywords = [
	'Software Engineering',
	'Clean Architecture',
	'Fullstack Web Development',
	'Mobile Development',
	'Digital Architecture',
	'SvelteKit',
	'TypeScript',
	'Drizzle ORM',
	'PostgreSQL',
	'Hono',
	'Deno',
	'Tailwind CSS',
	'Docker',
	'Terraform',
	'Cloud Computing',
	'DevOps',
	'Performance Optimization',
	'Security Best Practices',
	'SaaS Development',
	'Microservices'
];

export const socialMediaHandles = {
	facebook: 'Juslin.Komenan',
	x: '@misterjuslin', // old Twitter
	instagram: 'juslin_komenan',
	linkedin: 'juslin',
	youtube: 'MrJuslin',
	github: 'juslin03',
	threads: '@juslin_komenan'
};
